export const SEARCH_GROUP_START = 'SEARCH_GROUP_START';
export const SEARCH_GROUP_SUCCESS = 'SEARCH_GROUP_SUCCESS';
export const SEARCH_GROUP_ERROR = 'SEARCH_GROUP_ERROR';
